import projection from '../generated/pwj514f1.json';
import { AcceptanceManifest } from '../types';
export const pwj514f1AcceptanceManifest = projection as AcceptanceManifest;
